<template>
  <div v-if="items.length > 0">
    <span class="is-inline-block" v-for="(item, i) in items" :key="i" v-tooltip="item.actor + '@' + item.permission">
      {{item.actor}}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wallet/tx/Auth.vue